<template>
  <div class="pageContent" style="position:absolute;">
    <!--顶部一条-->
    <mu-appbar>
      <span class="topT">我的订单</span>
      <!--返回上一层-->
      <!--<mu-icon value="keyboard_arrow_left" color="white" style="margin-bottom: -0.05rem" slot="left" v-on:click="goback" />-->

      <!--<mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />-->

      <!--<mu-flat-button   label="登出" slot="left"   style=" color:#27ba69 "      />

        <mu-flat-button v-on:click="goback" label="登出" slot="right"  style=" margin-top:0.1rem"  />-->

    </mu-appbar>

    <div style="width:100% ; " align="center">
      <mu-tabs :value="activeTab" @change="handleTabChange">
        <mu-tab value="tab1" title="当前订单" />
        <mu-tab value="tab2" title="历史订单" />
      </mu-tabs>

      <!--第一页 - 当前订单页-->
      <div v-if="activeTab === 'tab1'" v-on:touchmove="loadPage(1)" v-on:touchend="loadEnd(1)">

        <!--<mu-refresh-control :refreshing="refreshing[0]" :trigger="trigger[0]" @refresh="refresh(1)" v-if=" this.loadMsg[0] !=''  "     />-->
        <mu-refresh-control :refreshing="refreshing[0]" :trigger="trigger[0]" @refresh="refresh(1)" />

        <!--灰条-->
        <div style=" background-color: #F5F5F5 ;height: 0.2rem"></div>
        <div style="width:92% ; margin:0 auto 0 auto " v-for="item in List1">

          <div v-on:click=" goDetail(item.ParentResvNo  , item.TotalPrice , '取消订单' ) " class="Grey">
            <div style="width:100%  ;  height:0.7rem  ; ">
              <span class="Orange" style="margin-left:5px ;margin-top:10px ;font-weight:700;font-size:0.28rem ; float:left">

                <div v-if=" item.State === 'NW' "> 应到未到 </div>
                <div v-if=" item.State === 'C0' "> 取消成功 </div>
                <div v-if=" item.State === 'C1' "> 退款失败 </div>
                <div v-if=" item.State === 'C2' "> 正在退款 </div>
                <!--支付宝创建支付信息但是没有支付  交易 进行中-->
                <div v-if=" item.State === 'R2'  "> 交易中</div>
                <div v-if=" item.State === 'R1' "> 交易失败 </div>
                <div v-if=" item.State === 'R999' "> 已入住 </div>
                <div v-if=" item.State === 'R0' && item.listResvPayInfo[0].PayStatus !='0' "> 预订成功 </div>

                <div v-if=" item.State === 'booking888' "> 预订 </div>

                <div v-if=" item.State === 'R0' && item.listResvPayInfo[0].PayStatus =='0' "> 已支付 </div>
              </span>
              <span style="margin-right:10px ; margin-top:10px ;font-size:0.24rem ; float:right  ">
                查看详情 &nbsp; >
              </span>
            </div>
            <!--线条-->
            <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>

            <table style="width:100%" align="center" border="0">
              <tr>
                <td style="width:26% ;  ">
                  <!--酒店图片-->
                  <img src="../../../static/order/LOGO_021003_4.jpg" style=" max-height:1.2rem ; max-width:1.6rem ; margin:-5% 0 0 -5%;" />
                </td>
                <td>
                  <!--右下部分-->
                  <div style="color:#333333 ; font-weight:700 ; width:98%"> {{ item.HotelName }} </div>

                  <div style=" padding-top:0.1rem;   line-height:1.6 ; font-size:0.22rem  ; float:left ;">
                    入住： {{ item.Arrivedate | dayTime }}
                    <br /> 离开： {{ item.Departuredate | dayTime }}
                    <br /> 房型： {{ item.RoomTypeNameNew+'(' + item.RoomTypeDisPlayNew+')' }} × {{item.RoomCount}}
                  </div>
                  <div style="color:#333333  ; float:right ; margin:0.2rem 0.15rem 0 0 ">
                    <span style="font-size:0.26rem ;   "> ￥ </span>
                    <span style="font-size:0.32rem ;   "> {{item.TotalPrice}} </span>
                  </div>

                </td>
              </tr>
            </table>

            <div v-if="item.IsRelax">
              <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
              <div style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" v-if=" item.listResvPayInfo[0].PayStatus =='0' ">
                备注：休闲房订单取消需提前到达时间4小时以上！
              </div>
              <div style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" v-if=" item.listResvPayInfo[0].PayStatus !='0' ">
                备注：该房间需在30分钟内完成支付，未完成支付将自动取消。
              </div>
            </div>

            <!-- 特惠房和休闲房是预定的订单只保留半小时。 显示的不一样   -->

            <div v-if="!item.IsRelax">
              <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
              <!--已支付-->
              <div style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" v-if=" item.listResvPayInfo[0].PayStatus =='0' ">
                备注：如遇特殊情况，不能及时入住，您可以在
                <span class="Orange" style="font-weight:600">【入住当日】18:00 </span>
                前免费取消订单。若未入住或过时取消，将收取您首日房费。
              </div>

              <!--未支付-->
              <div style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" v-if="   item.listResvPayInfo[0].PayStatus !='0' && item.IsSpecialRoom == false ">
                备注：如您到店较晚，建议您先支付房费，我们为您保留房间至
                <span class="Orange" style="font-weight:600" v-if="
                              this.Card_Kind_Diplay == '员工卡' || this.Card_Kind_Diplay == '数字卡' || this.Card_Kind_Diplay == '贵宾卡' 
                              ">【退房当日】13:00 </span>
                <span class="Orange" style="font-weight:600" v-if="
                              this.Card_Kind_Diplay == '贝壳卡' || this.Card_Kind_Diplay == '铂金卡' || this.Card_Kind_Diplay == '金卡' || this.Card_Kind_Diplay == '翡翠卡' || this.Card_Kind_Diplay == '联名卡' 
                              ">【退房当日】14:00 </span>
                ，期间可随时入住。
                <span class="Orange" style="font-weight:600">【入住当日】18:00 </span>
                之前取消订单可全额退款。超时或未入住将收取您首日房费。
              </div>

              <!--未支付-->
              <div style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" v-if="   item.listResvPayInfo[0].PayStatus !='0' && item.IsSpecialRoom == true  ">
                备注：特价房需要在30分钟内完成支付，未完成支付将自动取消。
              </div>
            </div>

            <!--线条-->
            <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
          </div>

          <!-- 带边框的按钮 -->
          <div style=" height:0.7rem ;  margin-top:0.2rem ; margin-bottom:0.1rem" v-if=" (item.State === 'R0' && item.listResvPayInfo[0].PayStatus !='0') ||  item.State === 'R2' ">

            <div style=" border:1px solid #27ba69 ; color:#27ba69 ; text-align:center; width:1.67rem ; height:0.57rem ; float:right ; " v-on:click="goPayMoney(item.ParentResvNo  , item.TotalPrice ,  item.HoldTime )">
              <div style=" padding-top:0.1rem ; font-size:0.24rem "> 支付房费 </div>
            </div>

            <div style=" width:0.3rem ; height:0.57rem ; float:right "> </div>
            <div style="   border:1px solid #cccccc ; color:#999999 ; text-align:center; width:1.67rem ; height:0.57rem;  float:right " v-on:click="CancelOrder(item.ParentResvNo )">
              <div style=" padding-top:0.1rem ; font-size:0.24rem "> 取消订单 </div>
            </div>
          </div>

          <div style=" height:0.7rem ;  margin-top:0.2rem ; margin-bottom:0.1rem" v-if=" item.State === 'R0' && item.listResvPayInfo[0].PayStatus =='0' ">

            <div style="   border:1px solid #cccccc ; color:#999999 ; text-align:center; width:1.67rem ; height:0.57rem;  float:right " v-on:click="CancelOrder(item.ParentResvNo )">
              <div style=" padding-top:0.1rem ; font-size:0.24rem "> 取消订单 </div>
            </div>
          </div>

          <div style=" background-color: #F5F5F5 ;height: 0.2rem  ;  width:114% ; margin-left:-7%"></div>

        </div>

        <!--加载状态语句 + 图标-->
        <div class="load" v-if="!loadState[0]" style=" background-color:#f5f5f5"> {{loadMsg[0]}} </div>
        <div class="loading" v-if="loadState[0]">
          <!--<mu-circular-progress :size="40"/>-->
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; margin-top:2.1rem" v-if="this.loadMsg[0] != '加载中...'" v-on:click=" refresh()" />
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; " v-if="this.loadMsg[0] == '加载中...'" v-on:click=" refresh()" />
        </div>
        <br />
        <br />
        <br />

      </div>

      <!--第二页-->
      <div v-if="activeTab === 'tab2'" v-on:touchmove="loadPage(2)" v-on:touchend="loadEnd(2)">

        <mu-refresh-control :refreshing="refreshing[1]" :trigger="trigger[1]" @refresh="refresh(2)" v-if=" this.loadMsg[1] !=''  " />

        <!--灰条-->
        <div style=" background-color: #F5F5F5 ;height: 0.2rem"></div>
        <div style="width:92% ; margin:0 auto 0 auto " v-for="item in List2">

          <div v-on:click=" goDetail(item.ParentResvNo  , item.TotalPrice  , '删除订单' ) " class="Grey">

            <div style="width:100%  ;  height:0.7rem  ; ">
              <span class="Orange" style="margin-left:5px ;margin-top:10px ;font-weight:700;font-size:0.28rem ; float:left">
                <div v-if=" item.State === 'NW' "> 应到未到 </div>
                <div v-if=" item.State === 'C0' "> 取消成功 </div>
                <div v-if=" item.State === 'C1' "> 退款失败 </div>
                <div v-if=" item.State === 'C2' "> 正在退款 </div>
                <div v-if=" item.State === 'R2' "> 交易中</div>
                <div v-if=" item.State === 'R1' "> 交易失败 </div>
                <div v-if=" item.State === 'R999' "> 已入住 </div>
                <div v-if=" item.State === 'R0' "> 预订成功 </div>
                <div v-if=" item.State === 'booking888' "> 预订 </div>

              </span>
              <span style="margin-right:10px ; margin-top:10px ;font-size:0.24rem ; float:right  ">
                查看详情 &nbsp; >
              </span>
            </div>
            <!--线条-->
            <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>

            <table style="width:100%" align="center" border="0">
              <tr>
                <td style="width:26% ;  ">
                  <!--酒店图片-->
                  <img src="../../../static/order/LOGO_021003_4.jpg" style=" max-height:1.2rem ; max-width:1.6rem ; margin:-5% 0 0 -5%;" />
                </td>
                <td>
                  <!--右下部分-->
                  <div style="color:#333333 ; font-weight:700 ; width:98%"> {{ item.HotelName }} </div>

                  <div style="line-height:1.6  ;  line-height:1.6 ; font-size:0.22rem  ; float:left ;">
                    入住： {{ item.Arrivedate | dayTime }}
                    <br /> 离开： {{ item.Departuredate | dayTime }}
                    <br /> 房型： {{ item.RoomTypeNameNew+'(' + item.RoomTypeDisPlayNew+')' }} × {{item.RoomCount}}
                  </div>
                  <div style="color:#333333  ; float:right ; margin:0.2rem 0.15rem 0 0 ">
                    <span style="font-size:0.26rem ;   "> ￥ </span>
                    <span style="font-size:0.32rem ;   "> {{item.TotalPrice}} </span>
                  </div>

                </td>
              </tr>
            </table>

            <!--线条-->
            <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
          </div>

          <!-- 带边框的按钮 -->
          <div style=" height:0.7rem ;  margin-top:0.2rem ; margin-bottom:0.1rem">

            <div style="   border:1px solid #cccccc ; color:#999999 ; text-align:center; width:1.67rem ; height:0.57rem;  float:right " v-on:click="DeleteOrder(item.ParentResvNo )">
              <div style=" padding-top:0.1rem ; font-size:0.24rem "> 删除订单 </div>
            </div>
          </div>

          <div style=" background-color: #F5F5F5 ;height: 0.2rem  ;  width:114% ; margin-left:-7%"></div>

        </div>

        <!--加载状态语句 + 图标-->
        <div class="load" v-if="!loadState[1]" style=" background-color:#f5f5f5 "> {{loadMsg[1]}} </div>
        <div class="loading" v-if="loadState[1]">
          <!--<mu-circular-progress :size="40"/>-->
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; margin-top:2.1rem" v-if="this.loadMsg[1] != '加载中...'" v-on:click=" refresh()" />
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; " v-if="this.loadMsg[1] == '加载中...'" v-on:click=" refresh()" />
        </div>
        <br />
        <br />
        <br />
      </div>

    </div>

    <!--弹出框 选择是否-->
    <mu-dialog :open="dialog" title="" @close="closeNO">
      <div style="color:#666666">
        <!--尊敬的客户，您确定取消订单吗？-->
        {{dialogMsg}}
      </div>
      <table style="width:100%">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeNO" primary="" label="取消" style="background-color:#cccccc ;color:white  " />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeYES" label="确定" style="background-color:#27BA69 ;color:white " />
          </td>
        </tr>
      </table>
    </mu-dialog>

    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

  </div>
</template>








<script>


import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'



export default {
  mounted() {
    this.trigger[0] = this.$el
    this.trigger[1] = this.$el
    this.trigger[2] = this.$el
  },
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_PayOrder'
    ]),
  },
  created() {
    this.refresh(1);

    this.tmpuser = this.g_UserInfo.OtherUserID;


    
  },
  activated() {

    console.log(this.tmpuser)
    console.log(this.g_UserInfo.OtherUserID)

    if(this.tmpuser != this.g_UserInfo.OtherUserID ){
      console.log('sdsd')
      this.refresh(1);
    }
    else if(this.$route.query.IsRef == "true"){
      console.log('sdsd2222222')
      this.refresh(1);
    }
  },
  data() {
    return {
      activeTab: 'tab1',

      refreshing: [false, false, false],
      trigger: [null, null, null],

      // 弹出层
      TellUser: '',
      toast: false,
      // 弹出标签 选择是否
      dialog: false,
      dialogMsg: '',

      List1: [],
      List2: [],


      OrderPage: [1, 1, 1],

      loadMsg: ['', '', ''],
      loadState: [true, true, true],


      cardno: '',

      ParentResvNo: '',

    }
  },
  methods: {
    //  订单列表页，在点击订单的时候把订单编号保存起来
    ...mapMutations([
      'setG_PayOrder',
    ]),

    refresh(type) {

      this.refreshing = true;

      this.loadMsg[type - 1] = '';

      this.loadState[type - 1] = true;

      this.List1 = [];
      this.List2 = [];

      this.getList(1, 1)
    },

    //跳转到支付页 - 保存下订单号
    goPayMoney(OrderId, TotalPrice, startDate) {

      var Order = this.g_PayOrder;
      // var Order = {};

      Order.OrderId = OrderId;
      Order.Money = TotalPrice;
      Order.Date = startDate;

      this.setG_PayOrder(Order);

      this.$router.push({ path: '/order/PayMoney' });
    },



    //跳转到支付页 - 保存下订单号
    // goDetail( OrderId , Money , startDate , TypeName ) {
    goDetail(OrderId, Money, TypeName) {


      var Order = this.g_PayOrder;

      Order.OrderId = OrderId;
      Order.Money = Money;
      Order.TypeName = TypeName;
      this.setG_PayOrder(Order);
      this.$router.push({ path: '/order/OrderDetails' });
    },




    getList(type, page) {



      var params = new this.URLSearchParam();
      params.append('phoneNo', this.g_UserInfo.OtherUserID);
      params.append('validateCode', this.g_UserInfo.YZM);
      params.append('pageIndex', 0);
      params.append('PageSize', 10);

      this.$http.post(api.QueryOrderWithoutLogin(), params.toParam()).then((res) => {


        if (res.Result) {

          res.Data.forEach(function(element) {
            var time1 = parseInt(element.Arrivedate.substring(6, 19));
            var date1 = new Date(time1);
            var time2 = parseInt(element.Departuredate.substring(6, 19));
            var date2 = new Date(time2);
            if (date2 - date1 == 14400000) {
              element.IsRelax = true
            }
            else {
              element.IsRelax = false
            }
          }, this);

          res.Data.forEach(function(ele) {
            if (ele.State == "R2" || ele.State == "R0") {
              this.List1.push(ele);
            }
            else {
              this.List2.push(ele);
            }
          }, this);

          if (this.List1.length == 10) {
            this.loadMsg[0] = '上拉加载更多';
          }
          else {
            this.loadMsg[0] = '没有更多记录';
          }
          this.$set(this.loadState, 0, false)


          if (this.List2.length == 10) {
            this.loadMsg[1] = '上拉加载更多';
          }
          else {
            this.loadMsg[1] = '没有更多记录';
          }
          this.$set(this.loadState, 1, false)
        }
        else {
          //调用弹出层
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },

    // 下拉刷新数据
    loadPage(type) {

      var body = window.document.body;
      //滚动条滚动的距离
      var scrollTop = body.scrollTop;
      //文档可视区高度
      var clientHeight = window.document.documentElement.clientHeight;
      //滚动条高度
      var scrollHeight = body.scrollHeight;

      if (clientHeight + scrollTop >= scrollHeight) {

        if (this.loadMsg[type - 1] == '上拉加载更多') {
          // this.loadState[ type-1 ] = true;
          // this.loadMsg[ type-1 ] = '加载中';

          this.$set(this.loadState, type - 1, true)
          this.$set(this.loadMsg, type - 1, '加载中')
        }
      }

    },


    loadEnd(type) {

      if (this.loadMsg[type - 1] == '加载中') {
        this.$set(this.loadMsg, type - 1, '加载中...')
        // this.getList(type, ++this.OrderPage[type - 1]);
        this.getList(1, 1)
      }

    },




    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser == '未登录' || this.TellUser == '验证码过期' || this.TellUser == '服务器错误') {
        this.$store.dispatch('clearUser');
        this.toastTimer1 = setTimeout(() => { this.$router.push({ path: '/user/OtherUser' }); }, 1200)
      }
      if (this.TellUser == '已登录') {
        setTimeout(() => { this.$router.push({ path: '/home/order' }); }, 1200)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end
    // 弹出标签 选择是否



    CancelOrder(ParentResvNo) {

      this.ParentResvNo = ParentResvNo;

      this.Cancel_Delete = 'cancel';

      this.dialog = true;
      this.dialogMsg = '尊敬的客户，确定取消订单吗？';

    },
    DeleteOrder(ParentResvNo) {

      this.ParentResvNo = ParentResvNo;

      this.Cancel_Delete = 'delete';

      this.dialog = true;
      this.dialogMsg = '尊敬的客户，确定删除订单吗？';

    },
    closeYES() {
      //  选项关闭
      this.dialog = false;


      var params = new this.URLSearchParam();
      params.append('parentNo', this.ParentResvNo);
      // params.append('phoneNo', this.ParentResvNo);  只有非协议订单用户才会有第二个参数
      params.append('phoneNo', this.g_UserInfo.OtherUserID);

      var tmpRoute = api.CancelResv();

      if (this.Cancel_Delete == 'delete') {
        tmpRoute = api.DeleteResv();
        // 加载动画
        this.$set(this.loadState, 1, true)
      }
      else{
        this.$set(this.loadState, 0, true)
      }
      this.$http.post(tmpRoute, params.toParam()).then((res) => {
        if (res.Result) {
          this.TellUser = res.Data;
          this.showToast();


          this.List1 = [];
          this.List2 = [];
          this.getList(1, 1);
        }
        else {
          this.TellUser = res.Message;
          this.showToast();

        }


      })
    },
    closeNO() {
      //  拒绝取消订单
      this.dialog = false;
    },
    // END 弹出标签 选择是否


    goback() {
      javascript: history.go(-1);
    },
    //三个分页
    handleTabChange(val) {
      this.activeTab = val
    },

  },

  // 跳转 登出
  goLogout() {
    // 接口登出
    this.$http.post(api.LogOff()).then((res) => {
      if (res.Result) {
        this.$store.commit('CLEARUSER');

        this.$router.push({ path: '/user/Login' });
      }
      else {
        this.TellUser = res.Message;
        this.showToast();
      }
    });
  },




}
</script>




// paper模块
<style lang="less" scoped>
@import "../../assets/theme.less";
.demo-paper {
  // 横向显示
  /*display: inline-block;*/
  margin: 8px;
  text-align: center;
  margin-top: 10px;
}

.green {
  color: @primaryColor ;
  border: 1px solid @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  color: @textColor; // 顶部标签变换
  .header {
    width: 100%
  }
  .mu-tabs {
    // 背景色
    background-color: #fff;
  } // 未选中时候的颜色
  .mu-tab-link {
    color: #999999;
    font-weight: bold;
  } //  选中  分页的
  .mu-tab-active {
    color: @primaryColor;
    font-weight: bold;
  } // END 顶部标签变换
  .Orange {
    color: @primaryOrange ;
  }
  .Black {
    color: @primaryBlack ;
  }
  .Grey {
    color: @textColor;
  }
}
</style>





// WEBPACK FOOTER //
// IndexToOther.vue?add9a25a